import { useFeatureFlags } from './useFeatureFlags';

export function useIsFeatureOn(featureName: string) {
  const { featureFlags } = useFeatureFlags();

  return featureFlags.isFeatureOn(featureName);
}
